import { type ReactNode } from "react";
import { Link } from "react-router";
import { ChevronIcon } from "vega-icons";

import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

type Props = {
  description: string;
  icon: ReactNode;
  title: string;
  onClick?: () => void;
  route?: string;
};

const cardClassName =
  "flex items-center gap-4 rounded-lg border border-border/primary p-4 hover:bg-background/secondary transition-colors";

export const ResourceCard = ({
  description,
  icon,
  title,
  onClick,
  route,
}: Props) => {
  const content = (
    <>
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border">
        {icon}
      </div>
      <div className="flex flex-1 flex-col gap-0.5">
        <span className="body-base-semibold">{title}</span>
        <span className="body-small-regular text-text/secondary">
          {description}
        </span>
      </div>
      <ChevronIcon className="shrink-0 text-text/secondary" />
    </>
  );

  if (onClick != null) {
    return (
      <button
        className={cnTwMerge("w-full text-left", cardClassName)}
        onClick={onClick}
        type="button"
      >
        {content}
      </button>
    );
  }

  if (route != null) {
    return (
      <Link className={cardClassName} to={route}>
        {content}
      </Link>
    );
  }

  return null;
};
